import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { usePodPanel, usePreApproval } from '../../pages/LandingPage';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { openPodPanel } = usePodPanel();
  const { openPreApproval } = usePreApproval();

  const quickLinks = [
    { label: 'Get Qualified', action: 'preapproval' },
    { label: 'Book a Call', href: 'https://link.oneforcelive.io/widget/bookings/oneforcelocal/consultation' },
    { label: 'Login to Platform', href: 'https://app.oneforcelive.io' },
    { label: 'Place an Order', action: 'pod' },
    { label: 'Become an Affiliate', href: 'https://www.oneforcelive.com/mybestylink' },
  ];

  const resourceLinks = [
    { label: 'Path Overview', href: '#path-overview' },
    { label: 'Step Details', href: '#steps' },
    { label: 'FAQ', href: '#faq' },
  ];

  const handleLinkClick = (link, e) => {
    if (link.action === 'preapproval') {
      e.preventDefault();
      openPreApproval();
    } else if (link.action === 'pod') {
      e.preventDefault();
      openPodPanel();
    }
  };

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <a href="/" className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-lg flex items-center justify-center overflow-hidden p-0.5">
                <img 
                  src="https://customer-assets.emergentagent.com/job_7626a04e-dabc-4736-ac34-e6d8b2aebead/artifacts/ybvtlwjp_New%20Branding%20CharactersDesign%20%281200%20x%201200%20px%29%20%28300%20x%20300%20px%29%20%281%20x%201%20in%29%20%281%20x%201%20in%29%20%28350%20x%20350%20px%29%20%2812%29.png" 
                  alt="AI Horse-Powered" 
                  className="w-full h-full object-cover rounded-md"
                />
              </div>
              <div>
                <span className="text-white font-semibold">One Force</span>
                <span className="text-emerald-400 font-semibold"> Live™</span>
              </div>
            </a>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              AI Horse-Powered Technology for business growth. The path to funding made clear, simple, and transparent.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Actions</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href || '#'}
                    target={link.href ? '_blank' : '_self'}
                    rel={link.href ? 'noopener noreferrer' : ''}
                    onClick={(e) => handleLinkClick(link, e)}
                    className="text-slate-400 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-semibold mb-4">Resources</h4>
            <ul className="space-y-3">
              {resourceLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target={link.href.startsWith('#') ? '_self' : '_blank'}
                    rel={link.href.startsWith('#') ? '' : 'noopener noreferrer'}
                    className="text-slate-400 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3 text-slate-400 text-sm">
                <Mail className="w-4 h-4 text-emerald-400 flex-shrink-0" />
                <span>support@oneforcefunding.com</span>
              </li>
              <li className="flex items-center space-x-3 text-slate-400 text-sm">
                <Phone className="w-4 h-4 text-emerald-400 flex-shrink-0" />
                <a href="tel:833-772-7397" className="hover:text-white transition-colors">
                  Text or Call Support @ 833-772-7397
                </a>
              </li>
              <li className="flex items-start space-x-3 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 text-emerald-400 flex-shrink-0 mt-0.5" />
                <span>Serving Best of Best businesses nationwide</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} One Force Live™. All rights reserved.
          </p>
          <p className="text-slate-600 text-xs">
            AI Horse-Powered Technology — The Workhorse of Your Business
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
